import axios from 'axios';

// The proxy in package.json will automatically handle forwarding 
// requests from /api to http://localhost:5000/api
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

// Add a request interceptor to include the auth token and cache-busting headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    // Add cache-busting headers to prevent 304 responses
    config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    config.headers['Pragma'] = 'no-cache';
    config.headers['Expires'] = '0';
    
    // Add timestamp to URL for GET requests to ensure fresh data
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now() // Add timestamp to prevent caching
      };
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle authentication errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Prevent redirect loop if already on login page
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      // Token expired or invalid, redirect to login
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api; 